import { render, staticRenderFns } from "./TabApp.vue?vue&type=template&id=56a384ba&scoped=true"
import script from "./TabApp.vue?vue&type=script&lang=ts"
export * from "./TabApp.vue?vue&type=script&lang=ts"
import style0 from "./TabApp.vue?vue&type=style&index=0&id=56a384ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a384ba",
  null
  
)

export default component.exports